import type { ReactNode } from "react";

import { classNames, Spinner, Text } from "@alpacahq/ui/old";

import { BackgroundLines } from "./BackgroundLines";

export interface OnboardingLayoutProps {
  title?: string;
  description?: string;
  titleTooltip?: ReactNode;
  isLoading?: boolean;
  currentStep?: number;
  totalSteps?: number;
  children?: ReactNode;
  onCancel?: () => void;
  containerClassNames?: string;
}

export const OnboardingLayout = ({
  title,
  description,
  titleTooltip,
  isLoading,
  currentStep,
  totalSteps,
  children,
  onCancel,
  containerClassNames,
}: OnboardingLayoutProps) => {
  return (
    <>
      <BackgroundLines />
      <section className="relative min-h-screen w-full">
        {isLoading ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <div
            className={classNames(
              "relative mx-auto flex w-full max-w-[648px] flex-col gap-8 px-6 py-10",
              containerClassNames,
            )}
          >
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-between gap-4">
                <button
                  type="button"
                  className="font-medium text-indigo-500 text-sm leading-5"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                {currentStep && totalSteps && (
                  <Text className="font-mono text-sm leading-5">
                    <span className="font-mono text-cool-gray-800">
                      Step {currentStep}
                    </span>
                    <span className="font-mono text-cool-gray-400">
                      {" "}
                      of {totalSteps}
                    </span>
                  </Text>
                )}
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between gap-2">
                  <h1 className="mb-0 font-semibold text-2xl text-cool-gray-800 leading-8">
                    {title}
                  </h1>
                  {titleTooltip}
                </div>
                <Text className="text-base text-cool-gray-700 leading-[22px]">
                  {description}
                </Text>
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between gap-8">
              {children}
            </div>
          </div>
        )}
      </section>
    </>
  );
};
